import Row from "@amzn/meridian/row";
import UploadSection from "src/components/pages/batchProcess/uploadSection";
import BatchJobView from "src/components/pages/batchProcess/batchJobView";
import React, { useEffect, useRef } from "react";
import ScrollableSection from "src/components/shared/scrollableSection/scrollableSection";
import { useAppDispatch, useAppSelector } from "src/store/store";
import {
  BatchExtractionJobView,
  BatchJobStatus,
  getBatchJobs,
} from "src/store/batchExtractionSlice";
import Column from "@amzn/meridian/column";

const BatchProcess = () => {
  const dispatch = useAppDispatch();
  const { token } = useAppSelector((state) => state.user);
  const { batchJobs } = useAppSelector((state) => state.batchExtractionSlice);
  const batchJobsRef = useRef(batchJobs);

  batchJobsRef.current = batchJobs;

  useEffect(() => {
    if (!token) return;

    const fetchJobs = () => dispatch(getBatchJobs());
    fetchJobs();

    const interval = setInterval(() => {
      if (document.visibilityState === "visible") {
        const hasJobsInProcess = batchJobsRef.current?.some(
          (job: BatchExtractionJobView) => job.status === BatchJobStatus.Processing,
        );
        if (hasJobsInProcess) {
          fetchJobs();
        }
      }
    }, 10000);

    return () => clearInterval(interval);
  }, [token]);

  return (
    <Row
      widths={["25%", "fit", "75%"]}
      alignmentVertical={"top"}
      spacingInset={"500"}
      spacing={"600"}
    >
      <Column alignmentHorizontal="end">
        <ScrollableSection>
          <UploadSection />
        </ScrollableSection>
      </Column>
      <div className="split-line"></div>
      <ScrollableSection>
        <BatchJobView />
      </ScrollableSection>
    </Row>
  );
};

export default BatchProcess;
